import resolveResponse from 'contentful-resolve-response'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {toConfirmationPage, toEntryCollection} from '../lib/types/contentful'
import {toResourceConfirmationPayload} from '../lib/types/payload'
import {Box, Grid} from '@primer/react-brand'
import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import {BreadcrumbsList} from '../components/BreadcrumbsList/BreadcrumbsList'
import RelatedResources from '../components/RelatedResources/RelatedResources'

export const ConfirmationPage = () => {
  const {contentfulRawJsonResponse, breadcrumbLinks} = toResourceConfirmationPayload(useRoutePayload<unknown>())
  const page = toConfirmationPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))
  const {template} = page.fields
  const {ctaBanner, relatedResources} = template.fields

  const breadcrumbs =
    breadcrumbLinks?.map(link => ({
      name: link.name,
      url: link.href,
    })) || []

  return (
    <>
      <Grid>
        <Grid.Column>
          {breadcrumbs.length > 0 ? (
            <Box marginBlockStart={20} marginBlockEnd={24}>
              <BreadcrumbsList items={breadcrumbs} />
            </Box>
          ) : null}

          {ctaBanner ? <ContentfulCtaBanner component={ctaBanner} /> : null}
        </Grid.Column>
      </Grid>

      {relatedResources && relatedResources.length > 0 && (
        <Grid className="mt-5 mt-lg-9 mb-5 mb-lg-10">
          <Grid.Column>
            <RelatedResources relatedResources={relatedResources} />
          </Grid.Column>
        </Grid>
      )}
    </>
  )
}

try{ ConfirmationPage.displayName ||= 'ConfirmationPage' } catch {}